// @mui
import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  ListItemText,
  ListItemAvatar,
  ListItem,
} from "@mui/material";
import Iconify from "../iconify";
import OptionPreview from "./OptionPreview";
import { useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import React, { useState } from "react";
import styled from "@emotion/styled";
// ----------------------------------------------------------------------
const DraggableList = React.memo(({ items, onDragEnd }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => (
              <div> {item.title_en} </div>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});
const QuoteItem = styled.div`
  width: 200px;
  border: 1px solid grey;
  margin-bottom: 8px;
  background-color: lightblue;
  padding: 8px;
`;
function Quote({ quote, index }) {
  return (
    <Draggable draggableId={quote.id} index={index}>
      {(provided) => (
        <QuoteItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {quote.title_en}
        </QuoteItem>
      )}
    </Draggable>
  );
}
const QuoteList = React.memo(function QuoteList({ quotes }) {
  return quotes.map((quote, index) => (
    <Quote quote={quote} index={index} key={quote.id} />
  ));
});
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
export default function QuestionsOrderingTable(props) {
  const [state, setState] = useState({ questions: props.questions });
  function onDragEnd(result) {
    console.log("result", result);
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const questions = reorder(
      state.questions,
      result.source.index,
      result.destination.index
    ).map((question, index) => {
      question.order = index;
      return question;
    });

    props.reorderHandler(questions);
    setState({ questions });
  }
  console.log("state.questions", state.questions);
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {state.questions.map((item, index) => (
              <Draggable
                key={item.question_id}
                draggableId={item.question_id.toString()}
                index={index}
              >
                {(provided, snapshot) => (
                  <ListItem
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <ListItemAvatar>
                      <Iconify icon="eva:flip-outline" />
                    </ListItemAvatar>
                    <ListItemText primary={item.title_en} secondary="" />
                  </ListItem>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
